module.exports = {
    iphone: 'Mobil terminal',
    lang: 'TR',
    langc: '中文',
    lange: 'English',
    langh: '繁体',
    name: 'Zhengzhou SmartGen Technology Co., Ltd. (Hisse Kodu: 301361.sz)',
    jieshao: "1998 yılında kurulan SmartGen, borsada işlem gören halka açık bir şirkettir (hisse kodu: 301361.sz). Şirket, motorlar, jeneratörler ve jeneratör setleri, yeni enerji mikro şebekeleri ve akıllı şebekeler için kontrol sistemlerinin araştırma ve geliştirme, üretim, satış ve servis hizmetlerinde uzmanlaşmıştır. SmartGen ürünleri, madencilik ve petrol çıkarma, yapay zeka veri merkezleri, gemiler, açık deniz adaları, akıllı binalar, sıfır karbonlu sanayi parkları, telekomünikasyon, altyapı ve ticari ve endüstriyel enerji depolama dahil olmak üzere çok çeşitli sektörlerde yaygın olarak kullanılmaktadır. Küresel bir varlığa sahip olan şirket, 50 'den fazla ülke ve bölgede ofis kurmuştur. Yüzlerce patente sahip olan ve iş gücünün %40'a yakını Ar-Ge'de çalışan SmartGen, \"Kontrolü Daha Akıllı Hale Getirmek\" temel felsefesine bağlı kalmaya devam etmektedir. Sektörde teknolojik ilerlemeye öncülük etme misyonuyla hareket eden SmartGen, yüksek kaliteli, güvenli, yeşil, düşük karbonlu ve sürdürülebilir bir endüstriyel ekosistem oluşturmak için sürekli olarak yenilik yapmakta ve gelişmektedir.",
    manualInChinese: 'Çince Kullanım Kılavuzu',
    englishManual: 'İngilizce Kullanım Kılavuzu',
    testingSoftware: 'Test Yazılımı',
    typicalApplicationDiagram: 'Tipik Uygulama Şeması',
    DModelDiagram: '3B Model Şeması',
    chineseSolution: 'Çince Çözüm',
    englishProgram: 'İngilizce Çözüm',
    aSinglePageInChinese: 'Çince Tek Sayfa',
    ProductSinglePage: 'Ürün Tek Sayfası',
    chineseCommunicationProtocol: 'Çince İletişim Protokolü',
    englishCommunicationProtocol: 'İngilizce İletişim Protokolü',
    shengming: 'Açıklama: SmartGen ürünlerini Çin içinde doğrudan satış ve Çin dışında yetkili distribütörler aracılığıyla satmaktadır. Tüm ürünler Zhengzhou, Çin fabrikasından doğrudan sevk edilmektedir.',
    inquire: 'Sorgula',
    notAvailable: 'Aranan içerik şu anda mevcut değil',
    nosousuo: 'Aradığınız içerik bulunamadı',
    BUG: 'Geri Bildirimde Bulun',
    loginerror: 'Lütfen sorgulama yapmadan önce giriş yapın',
    notLogIn: 'Giriş Yapılmadı',
    logIn: 'Giriş Yap',
    close: 'Kapat',
    download: 'İndir',
    theFreeCall: 'Ülke Çapında Ücretsiz Telefon',
    dataType: 'Veri Türü',
    all: 'Tümü',
    getCode: 'Doğrulama Kodunu Al',
    confirm: 'Onayla',
    cancel: 'İptal',
    login: {
        zhineng: 'Kontrolü daha akıllı hale getirin!',
        dizao: 'Yüz yıllık SmartGen\'i inşa edin, iş ortaklarının en güvenilir markası olun',
        zhinengxin: 'Dünyadaki her cihaz için daha akıllı bir kalp yaratın',
        fendou: 'İş ortaklarının çeşitli ve yüksek kaliteli ürün taleplerini karşılamak için sürekli çaba gösterin',
        welcome: 'Hoş Geldiniz',
        userName: 'Telefon Numarası/E-posta',
        password: 'Şifre',
        code: 'Doğrulama Kodu',
        logIn: 'Giriş Yap',
        register: 'Kayıt Ol',
        codelogin: 'Doğrulama Kodu ile Giriş',
        userlogin: 'Hesap ile Giriş',
        forgetPassword: 'Şifremi Unuttum',
        rememberPassword: 'Şifremi Hatırla',
        tishi: 'Uyarı: SmartGen Cloud Platform hesabı ile ortak kullanım',
        usermsg: 'Kullanıcı adı boş olamaz',
        pwdmsg: 'Şifre boş olamaz',
        codemsg: 'Doğrulama kodu boş olamaz',
        notnull: 'Boş bırakılamaz',
    },
    personal: {
        title: 'Kişisel Merkez',
        change: 'Değiştir',
        iphone: 'Telefon Numarası',
        notBound: 'Bağlı Değil',
        toBind: 'Bağla',
        email: 'E-posta Adresi',
        weititle: 'Bağlı değil, bağlandıktan sonra yeni ürün önerilerine abone olabilirsiniz',
        dyyj: 'E-posta Aboneliği',
        qxdy: 'Aboneliği İptal Et',
        changePassword: 'Şifreyi Değiştir',
        loginPassword: 'Giriş şifrenizi değiştirin',
        closeAnAccount: 'Hesabı Kapat',
        deldata: 'Hesabınızı ve ilgili verileri kalıcı olarak silin',
        logout: 'Çıkış Yap',
        changeNickname: 'Takma Adı Değiştir',
        replaceAPhoneNumber: 'Telefon Numarasını Değiştir',
        codeinput: 'Lütfen doğrulama kodunu girin',
        replaceTheEmail: 'E-postayı Değiştir',
        emailinput: 'Lütfen e-posta adresinizi girin',
        oldpassword: 'Lütfen eski şifrenizi girin',
        newpassword: 'Lütfen yeni şifrenizi girin',
        confirmpassword: 'Yeni şifreyi tekrar girin',
        modifySuccessfully: 'Başarıyla değiştirildi',
        iphonemsg: 'Lütfen geçerli bir telefon formatı girin',
        emailmsg: 'Lütfen geçerli bir e-posta formatı girin'
    },
    layout: {
        search: 'Ara',
        searchplaceholder: 'Lütfen içerik girin',
        home: 'Ana Sayfa',
        productcenter: 'Ürün Merkezi',
        productClassification: 'Ürün Kategorileri',
        Viewall: 'Tümünü Görüntüle',
        solution: 'Çözümler',
        application: 'Uygulama Örnekleri',
        technical: 'Teknik Destek',
        download: 'İndir',
        model: 'Model Seçimi Kataloğu',
        ECUfaultcode: 'ECU Arıza Kodu',
        FAQ: 'Sıkça Sorulan Sorular',
        Productfeedback: 'Kullanıcı Geri Bildirimi',
        ParameterComparison: 'Parametre Karşılaştırma',
        about: 'Hakkımızda',
        wenhua: 'SmartGen Kültürü',
        news: 'Şirket Haberleri',
        honor: 'Sertifikalar ve Ödüller',
        logo: 'Şirket Logosu',
        join: 'Bize katıl',
        contact: 'Bize Ulaşın',
        store: 'Mağaza',
        cloudplatform: 'SmartGen Cloud Platform',
        register: 'Kayıt Ol',
        login: 'Giriş Yap',
        userName: 'Kullanıcı Adı',
        exit: 'Çıkış Yap',
        followUs: 'Bizi Takip Edin',
        chineseWeChatServiceNumber: 'SmartGen Çince WeChat Abonelik Hesabı',
        englishWeChatServiceNumber: 'SmartGen İngilizce WeChat Servis Hesabı',
        productAPP: 'SmartGen',
        WeMedia: 'SmartGen Sosyal Medya',
        sumaitong: 'JD.com Mağazası',
        taobao: 'Taobao Mağazası',
        ali: 'Alibaba International',
        a1688: '1688',
        address: 'Çin · Henan Eyaleti · Zhengzhou Yüksek Teknoloji Bölgesi · Xuemei Caddesi No:28',
        weibo: 'SmartGen Weibo Platformu',
        weibourl: 'https://weibo.com/smartgenwb',
        boke: 'SmartGen Blog Platformu',
        bokeurl: 'http://blog.sina.com.cn/u/2490663307',
        tencentVideo: '',
        tencenturl: 'https://v.qq.com/s/videoplus/307236628',
        Youku: 'SmartGen Youku Videosu',
        Youkuurl: '',
        Tudou: '',
        Tudouurl: 'http://id.tudou.com/smartgen',
        DocIn: 'SmartGen Docin Dokümanları',
        DocInurl: 'http://www.docin.com/smartgen',
        baidu: 'SmartGen Baidu Dokümanları',
        baiduurl: 'https://cuttlefish.baidu.com/shop/a20ffe4733687e21af45a945',
        develop: 'Sürdürülebilir Kalkınma',
        xuanchuan: 'Tanıtım Videosu',
        quanjing: 'Sanal Sergi',
        contactUs: 'İletişim',
    },
    index: {
        NewProducts: 'Yeni Ürün Önerileri',
        BusinessBlock: 'İş Alanları',
        xuanze: 'Neden SmartGen\'i Seçmelisiniz?',
        dizao: 'Yüz yıllık SmartGen\'i inşa edin, iş ortaklarının en güvenilir markası olun!',
        zishen: 'Derin Sektör Deneyimi',
        lingyu: '1998\'de ilk nesil ürün geliştirmeye başladık, 20 yılı aşkın ürün geliştirme geçmişine sahibiz. Çin\'de jeneratör grupları ve çift güç kaynağı geçiş kontrol sistemleri geliştiren ve üreten ilk şirketlerden biriyiz. Küresel çapta 50\'den fazla ofis veya distribütör ağımız bulunmaktadır ve küresel endüstri pazarının en etkili ekipman üreticilerinden ve çözüm sağlayıcılarından biriyiz.',
        yingyong: 'Geniş Uygulama Alanları',
        yytext: 'Ürünlerimiz savunma, iletişim, enerji, inşaat, gemi, veri merkezleri, yangın söndürme ve hibrit enerji gibi alanlarda yaygın olarak kullanılmaktadır.',
        rongyu: 'Mükemmel Sertifikalar ve Ödüller',
        tixi: 'CCC, CE, CCS, BV, UL, ABS, RS sertifikaları ve Alman MTU laboratuvar sertifikası dahil olmak üzere birçok uluslararası sistem sertifikasına sahibiz. Ayrıca GB/T37089-2018 "Pistonlu İçten Yanmalı Motor Tahrikli AC Jeneratör Grubu Kontrolörleri" ulusal standardının hazırlanmasına katkıda bulunduk.',
        fengfu: 'Zengin Ürün Çeşitliliği',
        chanpins: 'Ürün yelpazemiz jeneratör grubu kontrolörleri, alçak gerilim dağıtım kontrolörleri, deniz motorları ve güç yönetim kontrolörleri (PMS), inşaat makineleri kontrolörleri, EMS, BMS, PCS, DVR, çift güç kaynağı anahtarları, akü şarj cihazları, motor ısıtıcıları, bulut izleme, iletişim dönüştürme modülleri, güç koruma modülleri, I/O genişletme modülleri gibi binlerce çeşit ürünü kapsamaktadır.',
        yanfa: 'Güçlü Ar-Ge Ekibi',
        yongyou: 'Şirket çalışanlarının %40\'a yakınını oluşturan profesyonel bir Ar-Ge ekibine sahibiz. Her yıl ürün geliştirme, akıllı üretim ve standart laboratuvarlara önemli yatırımlar yapıyoruz. Sektörde sayılı birinci sınıf ürün test merkezine sahibiz ve 500\'den fazla patent aldık.',
        zhuanye: 'Profesyonel Servis Personeli',
        zhuanyes: 'Şirket, ürün geliştirme, üretim, satış ve hizmeti bir arada sunmaktadır. Mükemmel satış ve satış sonrası hizmet sistemine sahibiz. Her bölgede, yerel satış öncesi ve satış sonrası hizmetlerden sorumlu uzman satış temsilcileri bulunmaktadır!',
        recentNews: 'Son Gelişmeler'
    },
    user: {
        account: 'Hesap',
        verificationCode: 'Doğrulama Kodu',
        newPassword: 'Yeni Şifre',
        confirmPassword: 'Şifreyi Onayla',
        retrievePassword: 'Şifreyi Kurtar',
        title: 'Şifre başarıyla ayarlandı, lütfen tekrar giriş yapın!',
        futitle: 'Lütfen yeni hesap şifrenizi unutmayın',
        loginImmediately: 'Hemen Giriş Yap',
        backHomepage: 'Ana Sayfaya Dön',
        mimamsg: 'Kullanıcı şifresi 5 ile 20 karakter arasında olmalıdır',
        reenter: 'Lütfen şifreyi tekrar girin',
        pwdb: 'Girilen şifreler uyuşmuyor'
    },
    reg: {
        mailbox: 'E-posta',
        password: 'Şifre',
        confirmPassword: 'Şifreyi Onayla',
        name: 'Takma Ad',
        mobilePhone: 'Telefon',
        companyName: 'Şirket Adı',
        companyIndustry: 'Şirket Sektörü',
        state: 'Ülke',
        address: 'Adres',
        register: 'Kayıt Ol',
        registeredSuccessfully: 'Başarıyla kayıt oldunuz',
        rememberAccount: 'Lütfen hesap bilgilerinizi unutmayın',
        namemsg: 'Kullanıcı takma adı boş olamaz',
        passwordmsg: 'Şifre boş olamaz',
        passwordmsg2: 'Şifre 5 ile 20 karakter arasında olmalıdır',
        phonemsg: 'Telefon numarası boş olamaz',
        phonemsg2: 'Lütfen geçerli bir telefon numarası girin',
        addressmsg: 'Adres boş olamaz',
        emtail: 'Lütfen geçerli bir e-posta adresi veya telefon numarası girin',
        reenter: 'Lütfen şifreyi tekrar girin',
        inconformity: 'Girilen şifreler uyuşmuyor',
        iphoneeamil: 'Lütfen telefon numarası veya e-posta adresi girin'
    },
    search: {
        searchResult: 'Arama Sonuçları',
        inquire: 'Sorgula',
        search: 'Ara',
        dedao: 'Sonuç bulundu',
        tiao: 'adet',
        all: 'Tümü',
        socialRecruitment: 'Sosyal İşe Alım',
        mobilePhone: 'Telefon',
        mailbox: 'E-posta',
        anlititle: 'SmartGen Uygulama Örnekleri'
    },
    project: {
        releaseTime: 'Yayınlanma Tarihi',
        all: 'Tüm Uygulama Örnekleri'
    },
    scheme: {
        planToDownload: 'Çözüm İndirme',
        solutionOverview: 'Çözüme Genel Bakış',
        shipin: 'İlgili Videolar',
        relatedCases: 'İlgili Örnekler',
        relatedProducts: 'İlgili Ürünler'
    },
    product: {
        problemFeedback: 'Sorun Geri Bildirimi',
        productOverview: 'Ürüne Genel Bakış',
        technicalParameters: 'Teknik Parametreler',
        shipin: 'İlgili Videolar',
        ziliao: 'Veri İndirme',
        relatedCases: 'İlgili Örnekler',
        relevantSolutions: 'İlgili Çözümler',
        versionNumber: 'Versiyon Numarası',
        downloadLink: 'İndirme Bağlantısı',
        WorkingPowerRange: 'Çalışma Güç Aralığı',
        OverallDimension: 'Genel Boyutlar (mm)',
        InstallationDimension: 'Montaj Boyutları (mm)',
        WorkingTemperature: 'Çalışma Sıcaklığı',
        ProductReferenceFont: 'Ürün Referans Yazı Tipi',
        weight: 'Ağırlık'
    },
    productinfo: {
        series: 'Seri',
        duibi: 'Karşılaştır',
        yiduibi: 'Zaten Karşılaştırıldı',
        fenlei: 'Kategori',
        xuanzexinghao: 'Model Seçin',
        qingxuanxinghao: 'Lütfen bir model seçin'
    },
    ecu: {
        brand: 'Marka',
        failureCause: 'Arıza Nedeni',
        reactionTitle: 'Arıza Tepkisi',
        ansTitle: 'Düzeltme Önlemleri'
    },
    fankui: {
        productModel: 'Ürün Modeli',
        productModelmsg: 'Ürün modeli boş olamaz',
        type: 'Tür',
        typeMsg: 'Ürün türü boş olamaz',
        function: 'Fonksiyonla İlgili',
        facade: 'Görünümle İlgili',
        software: 'Yazılımla İlgili',
        hardware: 'Donanımla İlgili',
        else: 'Diğer',
        describe: 'Açıklama',
        describemsg: 'Sorun açıklaması boş olamaz',
        improvementSuggestions: 'İyileştirme Önerileri',
        improvementSuggestionsmsg: 'İyileştirme önerileri boş olamaz',
        mailmsg: 'E-posta boş olamaz',
        submit: 'Gönder',
        operateSuccessfully: 'İşlem başarılı'
    },
    wenti: {
        problemDescription: 'Sorun Açıklaması',
        questionAnswering: 'Sorun Yanıtı',
    },
    ziliao: {
        searchhint: 'Çevrimiçi ve üretimden kaldırılan ürünleri arayın',
        model: 'Model',
        applicationTool: 'Uygulama Araçlarını İndir',
        name: 'Ad',
        desc: 'Ürün Açıklaması',
        dataDownload: 'Ürün Verilerini İndir',
        ziliaoDownload: 'Veri İndirme',
        efiDrawings: 'EFI Çizimleri',
        offdataDownload: 'Üretimden Kaldırılan Ürün Verileri',
        searchoffproduct: 'Üretimden kaldırılan ürün verilerini ara'
    },
    jiaru: {
        welfare: 'SmartGen Avantajları',
        jobVacancy: 'İş İlanları',
        Department: 'İşe Alım Departmanı',
        workingPlace: 'Çalışma Yeri',
        Zhengzhou: 'Zhengzhou',
        releaseDate: 'Yayınlanma Tarihi',
        recruitmentDetails: 'İşe Alım Detayları',
        salaryAndWelfare: 'Maaş ve Avantajlar',
        salaryAndWelfareinfo: 'Sektörde rekabetçi maaş standartları<br/>Sosyal sigorta + iş kazası sigortası<br/>Ücretsiz besleyici öğle yemeği',
        paidVacation: 'Ücretli İzin',
        paidVacationinfo: 'Ulusal resmi tatiller<br/>Evlilik, doğum, emzirme, babalık, yas, hastalık ve yıllık izinler<br/>Çalışanlara "doğum ve hastalık" durumlarında gerekli destek sağlanır',
        holidayGift: 'Tatlık Hediyeleri',
        holidayGiftinfo: 'Dragon Boat, Orta Sonbahar, Bahar Bayramı gibi tatil avantajları<br/>Her çeyrek bir günlük yaşam malzemeleri avantajı<br/>Doğum günü avantajları',
        culturalActivity: 'Kültürel Aktiviteler',
        culturalActivityinfo: 'Şirket düzeyinde: yıl dönümü, bira festivali, çalışan aile günü, yıl sonu partisi vb.<br/>Departman düzeyinde: düzenli yemekler, geziler, takım oluşturma aktiviteleri<br/>Kulüpler: Yaşam Kulübü, Okuma Kulübü, Sosyal Sorumluluk Kulübü, İş Görgü Kuralları Kulübü',
        talentCultivation: 'Yeteneği Geliştirme',
        talentCultivationinfo: 'Çeşitli "dışarı çık, içeri getir" eğitim ve öğrenme fırsatları<br/>Teknik, pazarlama, üretim, yönetim gibi çoklu kariyer gelişim yolları<br/>Mükemmel çalışan ödülü, yenilikçi iyileştirme ödülü, eğitim geliştirme ödülü, mesleki beceri geliştirme ödülü',
        employeeCare: 'Çalışanlara Özen',
        employeeCareinfo: 'Mesleki sağlık kontrolleri<br/>Tüm çalışanlar için sağlık taraması<br/>Kadın çalışanlar ve 40 yaş üstü çalışanlar için özel destek',
    },
    guanyu: {
        corporateMission: 'Şirket Misyonu',
        control: 'Kontrolü daha akıllı hale getirin!',
        spirit: 'Şirket Ruhu',
        spiritconetnt: 'Kendini geliştirme, kolektif zeka ile başarı.',
        vision: 'Şirket Vizyonu',
        visionconetnt: 'Yüz yıllık SmartGen\'i inşa edin, iş ortaklarının en güvenilir markası olun!',
        value: 'Şirket Değerleri',
        valueconetnt: 'Yenilik, odaklanma, mükemmellik; dürüstlük, sorumluluk, işbirliği ile kazan-kazan.',
        m: 'Ay',
        statement: 'Çevre Politikası',
        statementcontent: 'Teknolojik yenilikler yoluyla ISO14001 gibi standartlara uygun olarak kapsamlı süreç kontrolü ve yönetimi uyguluyoruz, gerçek bir yeşil şirket olmayı hedefliyoruz',
        developmentHistory: 'Gelişim Tarihi',
        contactUs: 'Bize Ulaşın',
        phone: 'Telefon',
        theForeignTradeInAStraightLine: 'Dış Ticaret Direkt Hattı',
        fax: 'Faks',
        pbx: 'Santral',
        postcode: 'Posta Kodu',
        mailbox: 'E-posta',
        QQ: 'QQ Teknik İletişim Grubu',
        controlField: 'Jeneratör grubu kontrol alanında',
        controlField2: 'sektör lideri ve standart belirleyici',
        controlFieldy: '20+ Yıl',
        agent: 'Yerel ofisler',
        agent2: 'denizaşırı distribütör satış modeli',
        agenty: '>50',
        patent: 'Sürekli yenilik, toplam',
        patent2: 'yüzlerce teknoloji patenti başvurusu',
        patenty: '>400',
        user: 'Çalışanların %40\'a yakını Ar-Ge\'ye adanmış',
        productBase: 'Üç küresel üretim üssü',
        user2: 'sektörün ön saflarında otomasyon çözümleri keşfetmek',
        usery: '>400',
        annualOutput: 'Yıllık >50.000 adet',
        annualOutput2: 'çeşitli kontrol modülü üretim kapasitesi',
        annualOutputy: '>50.000',
        informatization: 'Ofis ve üretim alanı',
        informatization2: 'toplam inşaat alanı >60.000 m²',
        informatizationy: '>60.000 m²',
        researchAndDevelopment: 'Ar-Ge Gücü',
        researchAndDevelopment2: 'Çalışanların %40\'a yakınını oluşturan profesyonel Ar-Ge ekibi, küresel endüstriyel ekipmanların genel performansını artırmak için yeni akıllı çözümler keşfetmeye adanmıştır.',
        smart: 'Akıllı Üretim',
        smart2: 'Endüstri 4.0 dijital üretim tesisi, yalın üretim yönetim modeli, çeşitli özelleştirilmiş ürün taleplerini karşılar.',
        quality: 'Kalite Güvencesi',
        quality2: 'Birinci sınıf standart laboratuvarlara sahip, ürün kalitesi uluslararası sektörün ilk sıralarında yer alır, dünya çapında milyonlarca cihaz güvenilir bir şekilde çalışmaktadır.',
        market: 'Uzman Satış',
        market2: 'Mühendis düzeyinde satış ekibi, tek duraklı yüksek verimli ve hassas hizmet sunar, küresel çapta binlerce uzun vadeli kaliteli müşteriye sahiptir.',
        laochang: 'Jinsuo Yolu Fabrikası',
        laochangaddress: 'Çin · Henan Eyaleti · Zhengzhou Yüksek Teknoloji Bölgesi · Jinsuo Yolu No:28',
        xinchang: 'Tianjian Gölü Fabrikası',
        xinchangaddress: 'Zhengzhou Yüksek Teknoloji Endüstri Bölgesi · Xuemei Caddesi No:28',
    },
    biaoshi: {
        title: 'SmartGen Logo Yorumu',
        content: 'SmartGen, SmartGen\'in İngilizce tescilli ticari markasıdır. Smart; zarif, akıllı, zeki anlamına gelir. Gen ise generator (jeneratör) kelimesinin kısaltmasıdır. SmartGen, jeneratör gruplarını daha akıllı, daha insancıl ve insanlığa daha iyi hizmet eder hale getirme anlamını taşır!',
        standardColors: 'Standart Renkler',
        brandStandardColor: 'Marka Standart Rengi',
        levels: 'Standart Renk Tonları',
        auxiliaryColor: 'Yardımcı Renkler',
        fuzhu: 'Standart renklerin uygulamalarda görsel bütünlüğünü ve uyumunu sağlamak için farklı malzeme ve üretim gereksinimlerine göre standart renklerle uyumlu bu yardımcı renkler seçilmiştir.',
        mascot: 'IP İmaj Yorumu',
        jxyy: 'Border Collie köpeğinden esinlenilmiştir, zeki, zarif ve akıllı anlamını taşır, aynı zamanda SmartGen İngilizce ticari markası ile uyumludur.',
        annotation: 'Anlam Yorumu',
        name: 'Adı Smart, Border Collie temelli tasarım, zeki ve akıllı anlamını taşır.',
        name2: 'Başı hafif kalkık, kulakları yukarı, enerjik ve canlı, şirketin dinamizmini ve büyümesini simgeler.',
        name3: 'Gözleri canlı, kaşları kısa ve keskin, ağzı hafif gülümser, özgüven ve pozitif enerji dolu.',
        logo: 'LOGO İndirme',
        Download: 'Dokümanı İndir'
    },
    lianxi: {
        placeholder: 'Lütfen eyalet düzeyindeki idari bölgelere bağlı şehir adını girin',
        companyName: 'Şirket Adı',
        theContact: 'İlgili Kişi',
        website: 'Web Sitesi',
        site: 'Adres',


        // contact sales
        contactSales: 'Satış Ekibiyle İletişime Geçin',
        intro: 'Ürünlerimizi satın almakla ilgileniyorsanız veya bunların işletmenize nasıl yardımcı olabileceğini öğrenmek istiyorsanız, lütfen hemen bizimle iletişime geçin; ekibimiz en kısa sürede size geri dönecektir.',
        name: 'Adınız',
        position: 'Pozisyonunuz',
        message: 'Mesajınız',
        email: 'E-postanız',
        department: 'Departmanınız',
        phone: 'İletişim Numaranız',
        submit: 'Gönder',
    },
    seo: {
        title: 'Jeneratör Grubu Kontrolörü, Hibrit Enerji Kontrolörü, Akıllı Geçiş Kontrolörü, Çift Güç Kaynağı Kontrolörü, İnşaat Makinesi Kontrolörü, Gemi Kontrolörü, Güç Yönetim Sistemi, Şarj Cihazı, Bulut İzleme, Isıtıcı',
        keywords: 'jeneratör grubu kontrolörü, dizel jeneratör grubu kontrolörü, hibrit enerji kontrolörü, akıllı geçiş kontrolörü, çift güç kaynağı kontrolörü, ATS kontrolörü, inşaat makinesi kontrolörü, gemi kontrolörü, deniz kontrolörü, güç yönetim sistemi, şarj cihazı, akü şarj cihazı, bulut izleme, grup bulut izleme, bulut izleme sistemi, ısıtıcı, grup ısıtıcı, su ceketli ısıtıcı',
        description: 'SmartGen, jeneratör grubu kontrolörleri, dizel jeneratör grubu kontrolörleri, hibrit enerji kontrolörleri, akıllı geçiş kontrolörleri, çift güç kaynağı kontrolörleri, ATS kontrolörleri, inşaat makinesi kontrolörleri, gemi kontrolörleri, deniz kontrolörleri, güç yönetim sistemleri, şarj cihazları, akü şarj cihazları, bulut izleme, grup bulut izleme, bulut izleme sistemleri, ısıtıcılar, grup ısıtıcılar, su ceketli ısıtıcılar gibi ürünlerin araştırma, geliştirme, üretim, satış ve hizmeti ile uğraşmaktadır.',
        indextitle: 'Jeneratör Grubu Kontrolörü, Hibrit Enerji Kontrolörü, Akıllı Geçiş Kontrolörü, Çift Güç Kaynağı Kontrolörü, İnşaat Makinesi Kontrolörü, Gemi Kontrolörü, Güç Yönetim Sistemi, Şarj Cihazı, Bulut İzleme, Isıtıcı',
        indexkeywords: 'dizel jeneratör grubu kontrolörü, jeneratör grubu kontrolörü, paralel kontrolör, jeneratör uzaktan izleyici, AMF, hibrit enerji kontrolörü, iletişim baz istasyonu kontrolörü, deniz feneri kontrolörü, gün doğumu/gün batımı deniz feneri kontrolörü, çift güç kaynağı kontrolörü, akıllı geçiş kontrolörü, ATS kontrolörü, çift güç kaynağı geçiş kontrolörü, bypass geçiş kontrolörü, ATS, ATSE, deniz kontrolörü, gemi kontrolörü, güç yönetim sistemi, PMS, entegre güç koruma modülü, anahtar genişletme modülü, yangın pompası kontrolörü, motor CAN izleme cihazı, dizel hava kompresörü kontrolörü, kırma kamyonu kontrolörü, endüstriyel uzaktan kumanda, çift güç kaynağı anahtarı, şarj cihazı, akü şarj cihazı, kurşun asit akü şarj cihazı, ısıtıcı, grup ısıtıcı, su ceketli ısıtıcı, güçlü dolaşımlı ısıtıcı, su ısıtıcı, motor yağı ısıtıcı, bulut izleme, bulut izleme sistemi, bulut platformu, kontrol paneli, kara jeneratör grubu kontrol paneli, ATSE kontrol paneli, gemi jeneratör kontrol paneli',
        indexdescription: 'SmartGen, jeneratör grubu üreticilerine jeneratör kontrolörleri, dizel jeneratör grubu kontrolörleri, paralel kontrolörler, jeneratör uzaktan izleyiciler, hibrit enerji kontrolörleri, iletişim baz istasyonu kontrolörleri, deniz feneri kontrolörleri, çift güç kaynağı kontrolörleri, akıllı geçiş kontrolörleri, çift güç kaynağı geçiş kontrolörleri, ATSE kontrolörleri, üç güç kaynağı geçiş kontrolörleri, deniz kontrolörleri, gemi kontrolörleri, güç yönetim sistemleri, PMS, entegre güç koruma modülleri, anahtar genişletme modülleri, yangın pompası kontrolörleri, motor CAN izleme cihazları, dizel hava kompresörü kontrolörleri, kırma kamyonu kontrolörleri, endüstriyel uzaktan kumandalar, endüstriyel makineler kontrol modülleri, endüstriyel uzaktan kumandalar, çift güç kaynağı anahtarları, şarj cihazları, akü şarj cihazları, kurşun asit akü şarj cihazları, ısıtıcılar, grup ısıtıcılar, su ceketli ısıtıcılar, güçlü dolaşımlı ısıtıcılar, su ısıtıcılar, motor yağı ısıtıcılar, bulut izleme, bulut izleme sistemleri, bulut platformları, kontrol panelleri, kara jeneratör grubu kontrol panelleri, ATSE kontrol panelleri, gemi jeneratör kontrol panelleri gibi ürünler sunmaktadır.',
        schemetitle: 'Jeneratör kontrol çözümleri, akıllı geçiş çözümleri, gemi kontrol çözümleri, inşaat makinesi çözümleri, bulut izleme çözümleri',
        schemekeywords: 'çoklu paralel çözümler, çoklu şebeke bağlantı çözümleri, AMF çözümleri, otomatik başlatma çözümleri, CHP çözümleri, gemi güç çözümleri, acil güç çözümleri, senkronizasyon ve yük paylaşım çözümleri, pompa grubu çözümleri, çift güç kaynağı geçiş çözümleri, üç güç kaynağı geçiş çözümleri, gaz jeneratörü çözümleri, siyah başlatma çözümleri, yüksek gerilim grubu çözümleri, telekomünikasyon baz istasyonu çözümleri, güç koruma çözümleri, deniz feneri grubu çözümleri, bulut izleme çözümleri',
        scheme: 'SmartGen, çoklu paralel çözümler, çoklu şebeke bağlantı çözümleri, AMF çözümleri, otomatik başlatma çözümleri, CHP çözümleri, gemi güç çözümleri, acil güç çözümleri, senkronizasyon ve yük paylaşım çözümleri, pompa grubu çözümleri, çift güç kaynağı geçiş çözümleri, üç güç kaynağı geçiş çözümleri, gaz jeneratörü çözümleri, siyah başlatma çözümleri, yüksek gerilim grubu çözümleri, telekomünikasyon baz istasyonu çözümleri, güç koruma çözümleri, deniz feneri grubu çözümleri, bulut izleme çözümleri gibi yeni akıllı çözümler sunmaktadır.'
    },
    pinglun: {
        fabiaopinglun: 'Yorum Yap',
        shuodianshenme: 'Bir şeyler söyle...',
        quanbupinglun: 'Tüm Yorumlar',
        huifu: 'Yanıtla',
        pinglun: 'Yorum'
    },
    develop: {
        kehutitle: 'Biz ve Müşterilerimiz',
        kehu1: 'SmartGen, kendini geliştirme ve kolektif zeka ile başarma ruhunu benimseyerek, yenilik, odaklanma, mükemmellik; dürüstlük, sorumluluk, işbirliği ile kazan-kazan değerlerini sürdürerek küresel endüstriyel ekipmanların genel performansını artırmak için yeni akıllı çözümler keşfetmeye devam ediyor.',
        kehu2: 'Müşteri odaklıyız, pazar gelişimini yönlendiriyoruz, her yıl ürün geliştirme, standart laboratuvarlar ve dijital fabrikalara önemli yatırımlar yaparak müşterilere beklentilerin ötesinde ürün çözümleri sunuyoruz;',
        kehu3: 'Şirketin uzman satış ekibi, müşteri ihtiyaçlarını çözmeyi görev edinmiş olup, müşterilere profesyonel, verimli ve kapsamlı teknik hizmetler sunmaktadır; çalışanların %40\'a yakınını oluşturan Ar-Ge personeli, müşterilerin çeşitli ürün ihtiyaçlarını karşılamak için sürekli çaba göstermektedir;',
        gongyingshangtitle: 'Biz ve Tedarikçilerimiz',
        gongyingshang1: 'SmartGen, "dürüstlük, sorumluluk, işbirliği ile kazan-kazan" iş prensibi ile tedarik zinciri ortaklarıyla birlikte büyümektedir. Dijital teknolojilerin uygulanması, yakın işbirliği ve ortak yenilik yoluyla işletme ve tedarik zincirinin sürdürülebilir kalkınma yeteneğini sürekli olarak geliştiriyoruz. Politika düzenlemelerini karşılamak ve uyumlu çalışmanın yanı sıra sosyal sorumluluklarımızı yerine getirerek karbon emisyonlarının insan çevresi üzerindeki etkisini azaltıyoruz. SmartGen, tedarik zinciri ortaklarımızla birlikte çaba göstererek, yeşil, şeffaf, sorumlu ve sürdürülebilir bir tedarik zinciri yönetim sistemi oluşturmayı ve ürün ve hizmetlerimizin çevre ve toplumun sürdürülebilir kalkınma gereksinimlerini kaynağından karşılamasını beklemektedir! Topluma ve insanlığa kendi katkımızı yapmak istiyoruz!',
        yuangongtitle: 'Biz ve Çalışanlarımız',
        yuangong1: 'Çalışanlar SmartGen\'in en değerli varlığıdır. SmartGen ve çalışanları birbirine güvenir, sorumluluk alır ve birlikte sağlıklı ve enerjik bir işletme ortamı oluşturur. SmartGen, çalışanların büyümesi ve gelişimi için bir sahne kurmaya çalışır, çalışanların potansiyelini tam olarak ortaya çıkarır ve her idealist çalışanın yeteneklerini sergileyebilmesini sağlar. "Yüz yıllık SmartGen" yolculuğunda çalışanların mutlu çalışmasını ve mutlu yaşamasını sağlamak istiyoruz!',
        shequtitle: 'Biz ve Toplum',
        shequ1: 'SmartGen, sosyal sorumluluklarını aktif olarak üstlenir, yerel topluluklara entegre olur ve eğitime katkıda bulunarak, çevreyi destekleyerek ve gönüllü faaliyetlerle toplumun sürdürülebilir kalkınmasına olan bağlılığını yerine getirir.',
        shequ2: 'SmartGen, yetenek, teknoloji, sermaye, kültür ve yönetim avantajlarını kullanarak toplumun çeşitli kesimleriyle işbirliği yapar ve yenilikçi yeteneklerin geliştirilmesine yardımcı olarak sosyal kalkınma ve medeniyet ilerlemesi için sürekli yenilikçi güç sağlar. Aynı zamanda SmartGen, sosyal refah projelerine aktif olarak katkıda bulunarak gerçekten sorumlu bir kurumsal vatandaş olmayı hedefler.',
        huanjingtitle: 'Biz ve Çevre',
        huanjing1: 'SmartGen, çevre ile uyum içinde yaşamayı hedefler. Yenilenebilir enerji, yeşil sistemler, yeşil ürünler ve tam kapsamlı yeşil operasyon uygulamaları ile çevre taahhüdünü yerine getirir. Enerji verimliliğini artırmak, emisyonları azaltmak, kaynakları korumak ve yenilenebilir enerji kullanımını teşvik etmek için sürekli yenilik felsefesi ile gelişir. Ürünlerin tüm yaşam döngüsü boyunca çevre yönetimini titizlikle uygular, araştırma, tasarım, tedarik, üretim, satış sonrası, lojistik ve geri dönüşüm süreçlerinin çevresel sürdürülebilirlik gereksinimlerini karşılamasını sağlar. Yeni çevresel sorunlar ve zorluklarla başa çıkmak için yeni yeşil ürünler ve teknolojiler geliştirmeye devam eder. SmartGen, çevre ile uyumlu kalkınmanın olumlu döngüsünü gerçekleştirmek, yeşil dağlar ve berrak suların inşasına katkıda bulunmak ve yeşil bir ekosistem oluşturmak için sosyal sorumluluklarını yerine getirmeyi hedefler.'
    }
}